var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5H12.5M7.5 17.5V13.3333M7.5 17.5H3C2.86739 17.5 2.74021 17.4473 2.64645 17.3536C2.55268 17.2598 2.5 17.1326 2.5 17V13.8333C2.5 13.7007 2.55268 13.5735 2.64645 13.4798C2.74021 13.386 2.86739 13.3333 3 13.3333H7.5M12.5 17.5V7.5M12.5 17.5H17C17.1326 17.5 17.2598 17.4473 17.3536 17.3536C17.4473 17.2598 17.5 17.1326 17.5 17V3C17.5 2.86739 17.4473 2.74021 17.3536 2.64645C17.2598 2.55268 17.1326 2.5 17 2.5H13C12.8674 2.5 12.7402 2.55268 12.6464 2.64645C12.5527 2.74021 12.5 2.86739 12.5 3V7.5M7.5 13.3333V8C7.5 7.86739 7.55268 7.74021 7.64645 7.64645C7.74021 7.55268 7.86739 7.5 8 7.5H12.5",
    stroke: "#87D234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports2);
export default __webpack_public_path__ + "static/media/reports2.aba673abab2b3858ebc49a6d8774a577.svg";
export { ForwardRef as ReactComponent };